export default "__VITE_ASSET__d2fb4cb2__"